/*
  globals moment
*/
import dspxMessageTpl from '../../tpl/dspx-message.html';
import dspxEntHistoryTpl from '../../tpl/dspx-entity-history.html';

(function(angular) {
  'use strict';

  var app = angular.module('asSupplyMgr');

  app.directive('dspxMessage', [
    '$http',
    function($http) {
      return {
        restrict: 'E',
        replace: true,
        template: dspxMessageTpl, // '/app/modules/demandmgr/static/tpl/dspx-message.html',
        scope: {
          text: '@',
          type: '@',
        },
      };
    },
  ]);

  app.directive('dspxEntityHistory', [
    '$http',
    function($http) {
      return {
        restrict: 'E',
        replace: true,
        template: dspxEntHistoryTpl,
        //  '/app/modules/demandmgr/static/tpl/dspx-entity-history.html',
        scope: {
          logData: '=',
        },
        link: function($scope, element) {
          $scope.page = {
            number: 0,
            size: 5,
          };

          $scope.floor = Math.floor;

          $scope.setPage = function(page) {
            $scope.page.number = page;
          };

          $scope.reviewLog = function(state) {
            $scope.stateToReview = state;
            $(element[0])
              .find('.modal')
              .modal('show');
          };
        },
      };
    },
  ]);
})(window.angular);

